import { Injectable } from '@angular/core';
import { Capacitor } from '@capacitor/core';
import { StatusBar, Style } from '@capacitor/status-bar';

/**
 * Provides centralized status bar management for iOS devices
 */
@Injectable({
	providedIn: 'root',
})
export class StatusBarService {
	/**
	 * StatusBar Service Constructor
	 */
	constructor() {}

	/**
	 * Sets the app's default status bar configuration
	 * Used after opening external files (PDF viewer, calendar files) to restore app styling
	 */
	async setAppStatusBar(): Promise<void> {
		if (Capacitor.getPlatform() !== 'ios') {
			return;
		}

		try {
			await StatusBar.hide();
			await StatusBar.show();

			await StatusBar.setStyle({ style: Style.Dark });
			await StatusBar.setBackgroundColor({ color: '#0d3d60' });
			await StatusBar.setOverlaysWebView({ overlay: false });
		} catch (error) {
			console.error('Error setting status bar:', error);
		}
	}
}
